import { isFunction } from 'lodash';

const dstm = window.dstm || {};

export class EventQueue {
  #queue = [];

  getQueue() {
    return this.#queue;
  }

  add(fn) {
    dstm.logger.debug('add - pre', { queue: this.#queue });
    this.#queue.push(fn);
    dstm.logger.debug('add - post', { queue: this.#queue });
  }

  process() {
    dstm.logger.debug('process', { queue: this.#queue });

    if (this.#queue.length === 0) {
      return;
    }

    const fn = this.#queue.shift();
    dstm.logger.debug('maybe calling function', { fn, isFunction: isFunction(fn) });
    if (isFunction(fn)) {
      fn();
    }

    if (this.#queue.length > 0) {
      this.process();
    }
  }

  clear() {
    dstm.logger.debug('clearing queue', { queue: this.#queue });
    this.#queue = [];
  }
}
